import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BoletoAvulso } from './boleto-avulso.model';
import { environment } from 'src/environments/environment';
import { Comprador } from './comprador.model';
import { Boleto } from './boleto.model';

@Injectable({
  providedIn: 'root'
})
export class BoletoService {

  constructor(private http: HttpClient) { }

  emitirBoleto(boleto: Boleto): Observable<Boleto> {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Boleto>(`${environment.apiUrl}/boletos`, boleto, { headers });
  }

  emitirBoletoAvulso(boleto: BoletoAvulso): Observable<BoletoAvulso> {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<BoletoAvulso>(`${environment.apiUrl}/boletos`, boleto, { headers });
  }

  buscarCep(cep: string): Observable<any> {
    return this.http.get<any>(`https://viacep.com.br/ws/${cep}/json`);
  }



}
